<template>
  <router-view name="contract" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Contract",
};
</script>
